export const PENDING_AUTH_STATUS = 'pending';
export const SUCCESS_AUTH_STATUS = 'success';
export const ERROR_AUTH_STATUS = 'error';
export const UNDEFINED_AUTH_STATUS = '';
